export default __webpack_public_path__ + "static/media/tab-clicked-blue.38f12e35.svg";